import React from 'react'
import styles from './OccasionPageGrid.module.css'
import LazyImage from 'app/theme/LazyImage'

export function OccasionPageGrid(props) {
  return (
    <div className={props.className}>
      <div className="container">
        {props.children}
      </div>
    </div>
  )
}

export function OccasionPageGridRow(props) {
  return (
    <div className={["flex flex-wrap", (props.reverse ? "flex-row-reverse" : "flex-row")]}>
      <div className="flex flex-auto w-full md:w-1/2 py-4 md:p-4 items-center justify-center">
        <LazyImage src={props.image} className={[props.imageClassName, "block max-w-full"]} />
      </div>
      <div className="flex flex-auto w-full md:w-1/2 py-4 lg:py-0 items-center justify-center">
        <div className={styles.grid_item_textbox}>
          <h3 className="text-navy text-2xl">
            {props.index ? (`${props.index}.`) : ""} {props.heading}
          </h3>
          <div className="font-light text-black text-md">{props.children || props.content}</div>
        </div>
      </div>
    </div>
  )
}
